import React, { useState } from 'react'
import { useTheme, useMediaQuery, makeStyles } from '@material-ui/core'
import { Box, Fab } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import AlertDialog from './AlertDialog'

const useStyles = makeStyles(theme => ({
    buttonWrapper: {
        textAlign: 'center',
        display: 'block'
    },
    button: {
        width: '100%!important',
        color: '#ffffff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important',
        minWidth: '140px!important',
        lineHeight: '15px',
        padding: '0 20px',
        marginBottom: 40
    },
    rightIcon: {
        marginLeft: 16
    },
    link: {
        textDecoration: 'none'
    },
    secondaryButton: {
        marginTop: -32,
        marginBottom: 16,
        width: '100%!important',
        background: '#e6e6e6!important',
        boxShadow: 'none!important',
        color: 'black',
        fontSize: '0.8rem',
        height: '30px!important',
        '&:hover': {
            background: '#f3f3f3!important'
        }
    },
    disabledButton: {
        background: '#e6e6e6!important',
        boxShadow: 'none!important'
    }
}))

export default function DynamicButton({ button, selectedOfferId, disabled }) {
    const classes = useStyles()

    const [isLoading, setIsLoading] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)
    const [label, setLabel] = useState(button.label)
    const [icon, setIcon] = useState(button.icon)
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [secondaryConfirmDialogOpen, setSecondaryConfirmDialogOpen] = useState(false)
    const [secondaryButton, setSecondaryButton] = useState(button?.secondaryButton)

    const handleApiClick = event => {
        if (!button.api) {
            return
        }
        event.preventDefault()
        if (isCompleted) {
            return
        }
        if (!button.confirmationQuestion) {
            handleApiClickConfirmed()
            return
        }
        setConfirmDialogOpen(true)
    }
    const handleApiClickConfirmed = () => {
        setIsLoading(true)
        setConfirmDialogOpen(false)
        const postFix = selectedOfferId ? '&offer_id=' + selectedOfferId : ''
        axios
            .get(button.url + postFix)
            .then(res => {
                const data = res.data
                setLabel(data.label)
                setIcon(data.icon)
                setIsLoading(false)
                setIsCompleted(true)
                setSecondaryButton(null)
            })
            .catch(error => {
                setIsLoading(false)
            })
    }

    const handleSecondaryApiClick = event => {
        if (!secondaryButton.api) {
            return
        }
        event.preventDefault()
        if (!secondaryButton.confirmationQuestion) {
            handleSecondaryApiClickConfirmed()
            return
        }
        setSecondaryConfirmDialogOpen(true)
    }

    const handleSecondaryApiClickConfirmed = () => {
        setIsLoading(true)
        setSecondaryConfirmDialogOpen(false)
        axios
            .get(secondaryButton.url)
            .then(res => {
                const data = res.data
                setLabel(data.label)
                setIcon(data.icon)
                setIsLoading(false)
                setIsCompleted(true)
                setSecondaryButton(null)
            })
            .catch(error => {
                setIsLoading(false)
            })
    }

    return (
        <>
            <AlertDialog
                open={confirmDialogOpen}
                title={button.confirmationQuestion?.title}
                message={button.confirmationQuestion?.description}
                yesLabel={button.confirmationQuestion?.yes}
                noLabel={button.confirmationQuestion?.no}
                handleYes={handleApiClickConfirmed}
                handleNo={() => setConfirmDialogOpen(false)}
            />
            {secondaryButton && (
                <AlertDialog
                    open={secondaryConfirmDialogOpen}
                    title={secondaryButton.confirmationQuestion?.title}
                    message={secondaryButton.confirmationQuestion?.description}
                    yesLabel={secondaryButton.confirmationQuestion?.yes}
                    noLabel={secondaryButton.confirmationQuestion?.no}
                    handleYes={handleSecondaryApiClickConfirmed}
                    handleNo={() => setSecondaryConfirmDialogOpen(false)}
                />
            )}
            <Box className={classes.buttonWrapper}>
                <a href={button.url} target="_blank" onClick={handleApiClick} className={classes.link}>
                    <Fab
                        variant="extended"
                        color="primary"
                        size="medium"
                        disabled={disabled || isLoading}
                        className={classes.button + ' forwardButton'}
                        classes={{ disabled: classes.disabledButton }}
                    >
                        {label}
                        {icon && !isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', icon]} />}
                        {isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'spinner-third']} spin />}
                    </Fab>
                </a>
                {secondaryButton && (
                    <a href={secondaryButton.url} target="_blank" onClick={handleSecondaryApiClick} className={classes.link}>
                        <Fab
                            variant="extended"
                            color="primary"
                            size="medium"
                            disabled={isLoading}
                            className={classes.button + ' ' + classes.secondaryButton + ' forwardButton'}
                        >
                            {secondaryButton.label}
                            {secondaryButton.icon && !isLoading && (
                                <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', secondaryButton.icon]} />
                            )}
                            {isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'spinner-third']} spin />}
                        </Fab>
                    </a>
                )}
            </Box>
        </>
    )
}
